<template lang="pug">
  div.target.targets
    div.toolbar
      div.line
        h1.title {{$route.meta ? $route.meta.title : '' }}
      div.line
        div.search-result
          span Всего {{items._meta.totalCount ? items._meta.totalCount : totalRowCount}} объектов

        form(
          @submit.prevent="letSearch"
          title="Введите слово либо фразу и нажмите Enter чтобы начать поиск"
        ).search
          input(type="search" placeholder="" v-model="searchModel")
        div.actions-panel
          e-button-delete(
            v-show="checkedRows"
            @click="onDeleteItem"
          title="Поставьте галочку напротив целевого показателя в таблице и нажмите сюда чтобы его удалить"
          ).actions-panel__button.btn-delete
          e-button-edit(
            v-show="checkedRows"
            :editOnly="true"
            @click="onEditItem"
            title="Поставьте галочку напротив целевого показателя в таблице и нажмите сюда чтобы его отредактировать"
          )
          e-button-add(
            @click="onCreateItem"
            title="Добавить целевой показатель"
          )
          e-button-add(
            v-if="hasItems"
            @click="addNewCol({})"
            label="Добавить столбец"
            btnDefaultClass=" "
          ).actions-panel__button.btn-text
          //button.actions-panel__button.btn-delete
          //button.actions-panel__button.btn-edit
          //button.actions-panel__button.btn-add.green(@click="showModalSmallTargets = !showModalSmallTargets")
          //button(@click="addNewCol({})").actions-panel__button.btn-text Добавить столбец

    div.content
      div(
        v-if="hasItems"
      ).table.tscroll.table--forEdit
       div.theader-wrapper
        table(cellspacing="0" ref="tableHeader")
          colgroup
            template(v-for="row, rowKey, index in rows")
              template(v-if="index === 0")
                col(
                 v-for="col, colIndex in row"
                 :width="col.width"
                )
          thead
            tr(v-for="headerRow in tableHeaders")
              th(
              v-for="headerCol, headerIndex in headerRow"
                :colspan="headerCol.colspan"
                  :rowspan="headerCol.rowspan"
                  :class="`field-${headerIndex} th-${headerCol.colspan || 0}-${headerCol.rowspan || 0}`"
              ) {{headerCol.value}}
                e-button-delete(
                  v-if="headerCol.columnEmpty === true"
                  @click="deleteEmptyColumn(headerCol.year)"
                )

        e-perfect-scrollbar(
          ref="tablePS"
          :emitTypes="['vue']"
          @ps-scroll-x="scrollHandler($event.event)"
          :config="{suppressScrollY: false, suppressScrollX: false}"
        )
         div.tbody-wrapper
          table(cellspacing="0")
            colgroup
             template(v-for="row, rowKey, index in rows")
              template(v-if="index === 0")
                col(
                v-for="col, colIndex in row"
                  :width="col.width"
                )
            tbody(ref="tableBody")
              tr(
                v-for="row, rowKey in rows"
                :data-id="row[0].id"
                :class="{'is-checked': (checkedRows === row[0].id)}"
              )
                td(
                  v-for="col, colIndex in row"
                  :title="colIndex > 2 ? 'Чтобы отредактировать значение используйте двойной клик' : 'Кликните по ряду и не отпуская кнопку мыши начните тянуть ряд вниз либо вверх чтобы сменить порядок'"
                )

                  div.flex-row(v-if="colIndex===0")
                    div.sortable
                      div.arrows
                        span.up
                        span.down
                    div.number №&nbsp;{{col.value}}
                    label.radioButton
                      input(
                      type="radio"
                        :value="col.id"
                      v-model="checkedRows"
                        @click="checkRow(col.id)"
                      ).radio
                      span

                  div(
                  v-if="!col._isEdit"
                    @dblclick="setEdit(col, colIndex)"
                      :title="colIndex > 3 ? 'Чтобы отредактировать значение используйте двойной клик' : 'Кликните по ряду и не отпуская кнопку мыши начните тянуть ряд вниз либо вверх чтобы сменить порядок'"
                  )
                    template(v-if="colIndex > 0")
                      template(v-if="col.value === null") -
                      template(v-else) {{col.value}}
                  div(
                  v-else
                  title="Нажмите Enter либо перестаньте редактировать значение чтобы его сохранить"
                  ).edit
                    input(
                      type="text"
                      @blur="saveEdit(col)"
                       @keyup.enter.prevent="saveEdit(col)"
                       v-model="col.value"
                    )
                    span.invalid.error.table-invalid {{col._error}}

      div(v-else).table.tscroll.table--forEdit.empty
        table(cellspacing="0")
          tr
            td Ничего не найдено...


    router-view

</template>

<script>
  import targetsTableMixin from './mixins/targets-table.js'
  import {indicator} from '../../api/api-endpoints.js'

  export default {
    name: 'targets',
    mixins: [targetsTableMixin],
    methods: {
      getObjectPlanFactUpdateUrl (id, year) {
        return indicator.objectPlanFactUpdate(id, year)
      },
      getEndpoint (route, fromRoute) {
        return indicator.objects(route)
      },
      getDeleteUrl (id) {
        return indicator.objectDelete(id)
      },
      getUpdateUrl (id) {
        return indicator.objectUpdateOrCreate(id)
      },
      getEmptyYearCol (year) {
        return indicator.objectEmptyYear(year)
      },
      getDeleteEmptyColumnUrl (year) {
        return indicator.objectDeleteEmptyYear(year)
      }
    }
  }
</script>
